import { ParcoursAction } from "@src/parcours/NavigationButtons/ParcoursAction";
import { ParcoursFullPageTemplate } from "@src/parcours/Template/ParcoursFullPageTemplate";
import {
  ParcoursRenouvellementStepComponentProps,
  RenouvellementStepEnum,
} from "@src/renouvellement/ParcoursRenouvellement.definition";
import { useEntreprises } from "@src/store/store.entreprise";
import { useMe } from "@src/store/store.me";
import style from "./RenouvellementIntroductionPage.module.scss";

export function RenouvellementOffertIntroductionPage({
  changeStep,
}: ParcoursRenouvellementStepComponentProps) {
  const { me } = useMe();
  const { entreprisesBySiren } = useEntreprises();

  if (!me || !entreprisesBySiren) return <div />;
  return (
    <ParcoursFullPageTemplate
      actions={
        <ParcoursAction
          onClick={() =>
            changeStep(
              RenouvellementStepEnum.RESUME_ENTREPRISE_RENOUVELLEMENT_OFFERT
            )
          }
        >
          Suivant
        </ParcoursAction>
      }
      title={
        <h1>
          Vous venez d&apos;adhérer à Endya et vous souhaitez renouveler votre
          adhésion pour l&apos;année{" "}
          {me.entreprisePrincipale.millesimeActuel + 1}. <br />
          <span className={style.textAccent}>
            Endya vous offre ce renouvellement.
          </span>
        </h1>
      }
    />
  );
}
